module.exports = __webpack_public_path__ + "static/CremeB-00ba76048f819554f34290db42c8ee41.jpg";